<template>
  <div id="loginPage">
    <div id="loginFormBox">
        <form id="loginForm" action="" v-on:submit="submitMessage">
        <div class="field">
<!--           <label class="label" for="u">Username</label> -->
          <div class="control has-icons-left">
            <input class="input" type="text" id="u" autocomplete="off" placeholder="Username" v-model="username" />
            <span class="icon is-small is-left">
                  <i class="fa fa-user"></i>
              </span>
          </div>
        </div>
        <div class="field">
<!--           <label class="label" for="p">Passwort</label> -->
          <div class="control has-icons-left">
            <input class="input" type="password" id="p" autocomplete="off" placeholder="Passwort" v-model="password" />
            <span class="icon is-small is-left">
                  <i class="fa fa-key"></i>
              </span>
          </div>
        </div>
          <button class="button is-info" type="submit">Login</button>
        </form>
    </div>
  </div>
</template>

<script>



export default {
  name: 'Login',
  data() {
    return {
      username: "",
      password: ""
        }
  },
  mounted: function(){
    this.username = "";
    this.password = "";
  },
  created: function(){
        //alert('ok');
        console.log('login created');
        },        
  methods: {
    submitMessage: function(e){
      e.preventDefault();
      
      var apiHttps = this.$config.apiHttps,
      apiWs = this.$config.apiWs,
      $this = this;      

        //console.log(this);
/*
      var username = $('#u').val().trim(),
        password = $('#p').val().trim();
*/
           
     if( this.username !="" && this.password !="" ) {
             
         $('input').unbind();    
                          
        $.post( apiHttps + '/login', {
          usrnm: this.username,
          psswrd: this.password,
          headers: {  'Access-Control-Allow-Origin': '*' }
        }).done(function (result) {
          
         console.log(result); 
          
        if(result.success) {  
          
          console.log(result);          
          $this.$store.state.auth = { token: result.token, loggedin: true, username: result.profile.username, profile: result.profile, user_id: result.profile.user_id };    

            
            
            //$this.$socket.query.token = result.token
            $this.$socket.connect({ query: {token: result.token} });
            
            //console.log( result.profile.role )
            
            var newRoute = '/cars';
            if( result.profile.role == 'dat' )
              $this.$store.state.currentRoute = "";
              newRoute = '/datfastrequest';

            this.username = "";
            this.password = "";


            $this.$router.replace( $this.$store.state.currentRoute != "" && $this.$store.state.currentRoute!='/login' ? $this.$store.state.currentRoute : newRoute);
            //$this.$socket.open();               
          } else {
            alert('Fehler u')
          }
          
        });
        
      } else {
        $('#loginForm').animateCss('shake');    
        $('input', '#loginForm').filter(function() { return this.value.trim() == ""; }).addClass('is-danger');
      }


      $('input').on('keyup', function(e){
        console.log('change');
        
        if( $(e.currentTarget).val() =="" )
          $('input', '#loginForm').filter(function() { return this.value.trim() != ""; }).addClass('is-danger');
        else 
          $('input', '#loginForm').filter(function() { return this.value.trim() == ""; }).removeClass('is-danger');
        
      });

      return false;
    }
  }  
}


    
</script>